<template>
  <modal-vue @close="handleToggleModal" :modalActive="modals[modalName]">
    <template #header>
      <div class="text-left text-lg px-[16px] flex">
        <strong>Legendas</strong>
      </div>
    </template>

    <v-row class="px-2 pb-2">
      <v-col cols="12" md="6">
        <div class="text-left px-2 pb-1 pt-2 flex">
          <strong>Alocação</strong>
        </div>
        <v-row dense>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table :legendColor="ELegendColor.alert" text="Aberta" :swatch="swatches.open" />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table :legendColor="ELegendColor.default" text="Fixo" :swatch="swatches.FIXO" />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendColor="ELegendColor.warning"
              text="Cobertura"
              :swatch="swatches.COBERTURA"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendColor="ELegendColor.neutral"
              text="Time externo"
              :swatch="swatches.offTeam"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendColor="ELegendColor.success"
              text="Extra"
              :swatch="swatches.EXTRA"
            />
          </v-col>
          <v-col v-if="showUnidentified" cols="12" class="py-1 px-2">
            <!-- Mockup M1: mesmo desenho do card da grade (hachura + barra lateral) e selo
                 "NOVO"; o Legend.vue genérico só desenha bolinha. -->
            <div
              class="flex items-center gap-2 text-sm font-bold text-textPrimary whitespace-nowrap"
              data-testid="legend-unidentified-entry"
            >
              <span class="legend-unidentified-swatch" aria-hidden="true"><i></i></span>
              {{ COVERAGE_STATUS_LABELS[CoverageStatus.UNIDENTIFIED] }}
              <span class="legend-new-tag" data-testid="legend-unidentified-new-tag">NOVO</span>
            </div>
          </v-col>
        </v-row>

        <div class="text-left px-2 pb-1 pt-4 flex">
          <strong>Avisos</strong>
        </div>
        <v-row dense>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table :legendColor="ELegendColor.yellowAlert" text="Alerta leve" />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table :legendColor="ELegendColor.alert" text="Alerta grave" />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table :legendColor="ELegendColor.negative" text="Alerta crítico" />
          </v-col>
        </v-row>

        <div class="text-left px-2 pb-1 pt-4 flex">
          <strong>Médico</strong>
        </div>
        <v-row dense>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiTextBoxCheck"
              :legendColor="ELegendColor.warning"
              text="Possui observações"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiClockAlertOutline"
              :legendColor="ELegendColor.neutral"
              text="Não confirmado"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiClockCheckOutline"
              :legendColor="ELegendColor.success"
              text="Confirmado"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiAccountAlert"
              :legendColor="ELegendColor.default"
              text="Médico pendente"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <div class="text-left px-2 pb-1 pt-2 flex">
          <strong>Registro de plantão</strong>
        </div>
        <v-row dense>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.DISPONIBILIZADO_PARA_CHECKIN].icon
              "
              :legendColor="ELegendColor.primary"
              :text="
                doctorStationStatusTranslate[DoctorStationStatus.DISPONIBILIZADO_PARA_CHECKIN].text
              "
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.CHECKIN_NAO_REALIZADO].icon
              "
              :legendColor="ELegendColor.primary"
              :text="doctorStationStatusTranslate[DoctorStationStatus.CHECKIN_NAO_REALIZADO].text"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.CHECKIN_REALIZADO].icon
              "
              :legendColor="ELegendColor.primary"
              :text="doctorStationStatusTranslate[DoctorStationStatus.CHECKIN_REALIZADO].text"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.CHECKIN_REALIZADO_COM_ATRASO].icon
              "
              :legendColor="ELegendColor.primary"
              :text="
                doctorStationStatusTranslate[DoctorStationStatus.CHECKIN_REALIZADO_COM_ATRASO].text
              "
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.DISPONIBILIZADO_PARA_CHECKOUT].icon
              "
              :legendColor="ELegendColor.primary"
              :text="
                doctorStationStatusTranslate[DoctorStationStatus.DISPONIBILIZADO_PARA_CHECKOUT].text
              "
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.CHECKOUT_NAO_REALIZADO].icon
              "
              :legendColor="ELegendColor.primary"
              :text="doctorStationStatusTranslate[DoctorStationStatus.CHECKOUT_NAO_REALIZADO].text"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[DoctorStationStatus.CHECKOUT_REALIZADO].icon
              "
              :legendColor="ELegendColor.primary"
              :text="doctorStationStatusTranslate[DoctorStationStatus.CHECKOUT_REALIZADO].text"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :dynamicComponent="
                doctorStationStatusTranslate[
                  DoctorStationStatus.CHECKOUT_REALIZADO_COM_ANTECEDENCIA
                ].icon
              "
              :legendColor="ELegendColor.primary"
              :text="
                doctorStationStatusTranslate[
                  DoctorStationStatus.CHECKOUT_REALIZADO_COM_ANTECEDENCIA
                ].text
              "
            />
          </v-col>
        </v-row>

        <div class="text-left px-2 pb-1 pt-4 flex">
          <strong>Excepcionalidade</strong>
        </div>
        <v-row dense>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiLock"
              :legendColor="ELegendColor.alert"
              text="Em Andamento"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiLockOpenVariant"
              :legendColor="ELegendColor.negative"
              text="Aprovado"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiLockOpenVariant"
              :legendColor="ELegendColor.yellowAlert"
              text="Em revisão"
            />
          </v-col>
        </v-row>

        <div class="text-left px-2 pb-1 pt-4 flex">
          <strong>Pós-Plantão</strong>
        </div>
        <v-row dense>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiClockEnd"
              :legendColor="ELegendColor.success"
              text="Avaliação aprovada"
            />
          </v-col>
          <v-col cols="12" class="py-1 px-2">
            <legend-table
              :legendIcon="mdiClockEnd"
              :legendColor="ELegendColor.alert"
              text="Revisar avaliação"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </modal-vue>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import {
  DoctorStationStatus,
  doctorStationStatusTranslate
} from '@/translations/doctor.station.status'
import {
  mdiTextBoxCheck,
  mdiAccountAlert,
  mdiClockAlertOutline,
  mdiClockCheckOutline,
  mdiClockEnd,
  mdiLock,
  mdiLockOpenVariant
} from '@mdi/js'
import LegendTable, { ELegendColor } from '@/components/others/Legend.vue'
import { useLegendShowsUnidentified } from './useLegendShowsUnidentified'
import { stationPalette } from '@/theme/stationPalette'
import { COVERAGE_STATUS_LABELS } from '@/utils/coverage'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'

// Paleta v3: bolinhas de Alocação com os hex da paleta; antiga: classes de hoje (swatch vazio).
const palette = stationPalette()
const legacyPalette = palette.id === 'legacy'
const swatches = {
  open: legacyPalette ? '' : palette.open.stripe,
  FIXO: legacyPalette ? '' : palette.type.FIXO.stripe,
  COBERTURA: legacyPalette ? '' : palette.type.COBERTURA.stripe,
  offTeam: legacyPalette ? '' : palette.offTeam.stripe,
  EXTRA: legacyPalette ? '' : palette.type.EXTRA.stripe
}

/* ******** Modal Props and Actions Default *********** */
const modalName = EModals.LEGENDS
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
/* **************************************************** */

// "Ocupado s/ identificação" só quando a resposta conhece o estado (mesma regra da legenda V2).
const showUnidentified = useLegendShowsUnidentified()
</script>

<style scoped>
/* Ocupado sem identificação (mockup M1): mesma hachura e barra lateral do card da grade. */
.legend-unidentified-swatch {
  display: inline-flex;
  flex: 0 0 auto;
  width: 22px;
  height: 16px;
  overflow: hidden;
  border-radius: 2px;
  background: repeating-linear-gradient(135deg, #eeeef3 0 4px, #e1e1ea 4px 8px);
}
.legend-unidentified-swatch i {
  width: 5px;
  background: #68688d;
}
.legend-new-tag {
  padding: 0 4px;
  border-radius: 3px;
  background: #2f7f91;
  color: #fff;
  font-size: 9.5px;
  font-weight: 700;
  line-height: 16px;
}
</style>
